import type { FC } from "react";
import { Icon } from "../../common/Icon";

interface ComparisonIndicatorProps {
	change: number;
	invertColor?: boolean;
}

export const ComparisonIndicator: FC<ComparisonIndicatorProps> = ({
	change,
	invertColor = false,
}) => {
	const isPositive = change >= 0;
	const isGood = invertColor ? !isPositive : isPositive;

	return (
		<span
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: 2,
				fontSize: "0.75rem",
				color: isGood ? "#0EA791" : "#d63939",
			}}
		>
			<Icon name={isPositive ? "arrow_upward" : "arrow_downward"} size={12} />
			{Math.abs(change).toFixed(1)}%
		</span>
	);
};
